module.exports = __webpack_public_path__ + "media/images/donation/logo-ufj-edfc39233c5e314cb8d9ce611f5d7107.jpg";